class ApiError extends Error {
    /**
     * @param {string} message
     * @param {?number} statusCode
     * @param {?object} responseData
     * @param {?AxiosResponse} rawResponse
     */
    constructor(
        message,
        statusCode,
        responseData = {},
        rawResponse = {}
    ) {
        super(message);

        this.statusCode = statusCode;
        this.responseData = responseData;
        this.response = rawResponse;

        /**
         * @type {import('axios').AxiosRequestConfig|null}
         */
        this.requestConfig = null;

        this.name = 'ApiError';
    }

    /**
     * @param {import('axios').AxiosRequestConfig} requestConfig
     *
     * @returns {ApiError}
     */
    setRequestConfig(requestConfig) {
        this.requestConfig = requestConfig;

        return this;
    }
}

module.exports = ApiError;
